import { render, staticRenderFns } from "./medicalOrderDetail.vue?vue&type=template&id=06d63c2a&scoped=true&"
import script from "./medicalOrderDetail.vue?vue&type=script&lang=js&"
export * from "./medicalOrderDetail.vue?vue&type=script&lang=js&"
import style0 from "./medicalOrderDetail.vue?vue&type=style&index=0&id=06d63c2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06d63c2a",
  null
  
)

export default component.exports